export default __webpack_public_path__ + "a93b01a7052e08dec0ed956967023891.jpg";